export default __webpack_public_path__ + "static/media/Delete Account Instruction.58743848.jpeg";